/**
 * SerialVerificationBlock — P1-5: сверка серийников из задачи с базой оборудования.
 * Цветная таблица FOUND / NOT_FOUND (данные приходят с бэка в preview.serial_verification).
 */
import { CheckCircle2, XCircle } from 'lucide-react'
import type { SerialVerificationRow } from '../../types/workOrder'

export function SerialVerificationBlock({ rows }: { rows?: SerialVerificationRow[] }) {
  if (!rows || rows.length === 0) return null

  return (
    <div className="rounded-lg border border-border/40 bg-bg-input/40 p-3" data-testid="serial-verification">
      <p className="text-xs font-bold text-text-muted uppercase tracking-widest mb-2">
        Сверка серийников ({rows.length})
      </p>
      <div className="space-y-1">
        {rows.map((r, i) => (
          <div
            key={i}
            className={`flex items-center gap-2 rounded px-2 py-1.5 text-xs ${
              r.status === 'FOUND'
                ? 'bg-status-normal/10 border border-status-normal/20'
                : 'bg-status-critical/10 border border-status-critical/20'
            }`}
          >
            {r.status === 'FOUND' ? (
              <CheckCircle2 className="w-3.5 h-3.5 text-status-normal shrink-0" />
            ) : (
              <XCircle className="w-3.5 h-3.5 text-status-critical shrink-0" />
            )}
            <span className="font-mono text-text-primary">{r.serial}</span>
            {r.status === 'FOUND' ? (
              <span className="text-text-muted truncate">
                → {r.equipment_name} (стойка #{r.rack_id})
              </span>
            ) : (
              <span className="text-status-critical/80">не найден в базе</span>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
